export const isEmptyObject = (obj) => {
  return Object.values(obj).some((element) => !element || element === "");
};
